import * as Types from '../graphql.generated';

import { AreaFragment } from '../area.fragment.generated';
import { MarketActivityFragment } from '../components/MarketActivity/MarketActivity.fragment.generated';
import { gql } from '@apollo/client';
import { AreaFragmentDoc } from '../area.fragment.generated';
import { MarketActivityFragmentDoc } from '../components/MarketActivity/MarketActivity.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type PropertiesSearchResponseErrorFragment = {
    __typename?: 'PropertiesSearchResponseError';
} & {
    errors?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'PropertiesSearchErrorMessage' } & Pick<
                    Types.PropertiesSearchErrorMessage,
                    'message'
                >
            >
        >
    >;
};

export type PropertiesSearchConnectionFragment = {
    __typename?: 'PropertiesSearchConnection';
} & Pick<Types.PropertiesSearchConnection, 'totalResults'> & {
        pageInfo: { __typename?: 'PageInfo' } & Pick<
            Types.PageInfo,
            'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'
        >;
        metaData?: Types.Maybe<
            { __typename?: 'PropertiesSearchMetaData' } & Pick<
                Types.PropertiesSearchMetaData,
                | 'geoAlias'
                | 'geoDescription'
                | 'geoName'
                | 'geoCountyAreaName'
                | 'geoPostalArea'
                | 'geoPostTownName'
                | 'geoRegionName'
                | 'geoOutcode'
                | 'geoOutcodes'
                | 'geoIncode'
            > & {
                    input?: Types.Maybe<
                        { __typename?: 'PropertiesSearchMetaInput' } & Pick<
                            Types.PropertiesSearchMetaInput,
                            'geoString' | 'geoIdentifier'
                        >
                    >;
                }
        >;
        edges?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'PropertiesSearchEdge' } & Pick<
                        Types.PropertiesSearchEdge,
                        'cursor'
                    > & {
                            node?: Types.Maybe<
                                { __typename?: 'Property' } & Pick<
                                    Types.Property,
                                    'uprn' | 'propertyId'
                                > & {
                                        lastSale?: Types.Maybe<
                                            {
                                                __typename?: 'LastSaleData';
                                            } & Pick<
                                                Types.LastSaleData,
                                                'date' | 'price'
                                            >
                                        >;
                                        address?: Types.Maybe<
                                            { __typename?: 'Address' } & Pick<
                                                Types.Address,
                                                | 'uprn'
                                                | 'fullAddress'
                                                | 'postcode'
                                            >
                                        >;
                                        attributes?: Types.Maybe<
                                            {
                                                __typename?: 'Attributes';
                                            } & Pick<
                                                Types.Attributes,
                                                | 'bathrooms'
                                                | 'bedrooms'
                                                | 'livingRooms'
                                                | 'propertyType'
                                                | 'tenure'
                                            >
                                        >;
                                        saleEstimate?: Types.Maybe<
                                            {
                                                __typename?: 'SaleEstimate';
                                            } & Pick<
                                                Types.SaleEstimate,
                                                'lowerPrice' | 'upperPrice'
                                            >
                                        >;
                                        trackedProperty?: Types.Maybe<
                                            {
                                                __typename?: 'TrackedProperty';
                                            } & Pick<
                                                Types.TrackedProperty,
                                                'isTracked' | 'relationship'
                                            >
                                        >;
                                    }
                            >;
                        }
                >
            >
        >;
    };

export type HousePricesResultsQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
    geoIdentifier?: Types.Maybe<Types.Scalars['GeoIdentifier']>;
    geoString?: Types.Maybe<Types.Scalars['NonEmptyString']>;
    houseType?: Types.Maybe<Types.HouseType>;
    rangeMonths?: Types.Maybe<Types.MarketActivityWindow>;
    after?: Types.Maybe<Types.Scalars['ID']>;
    first?: Types.Maybe<Types.Scalars['PositiveInt']>;
    fromLastSaleDate?: Types.Maybe<Types.Scalars['String']>;
    propertyTypeCode?: Types.Maybe<Types.Scalars['String']>;
    sortDirection?: Types.Maybe<Types.Scalars['String']>;
    sortOrder?: Types.Maybe<Types.Scalars['String']>;
    toLastSaleDate?: Types.Maybe<Types.Scalars['String']>;
}>;

export type HousePricesResultsQuery = { __typename?: 'Query' } & {
    propertiesSearch:
        | ({
              __typename?: 'PropertiesSearchConnection';
          } & PropertiesSearchConnectionFragment)
        | ({
              __typename?: 'PropertiesSearchResponseError';
          } & PropertiesSearchResponseErrorFragment);
    area?: Types.Maybe<{ __typename?: 'Area' } & AreaFragment>;
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & {
                text: Types.Breadcrumbs['label'];
                id: Types.Breadcrumbs['tracking'];
                href: Types.Breadcrumbs['uri'];
            }
        >
    >;
    marketActivity?: Types.Maybe<
        { __typename?: 'MarketActivityStats' } & MarketActivityFragment
    >;
    yearAllActivity?: Types.Maybe<
        { __typename?: 'MarketActivityStats' } & MarketActivityFragment
    >;
    yearDetachedActivity?: Types.Maybe<
        { __typename?: 'MarketActivityStats' } & MarketActivityFragment
    >;
    yearSemiActivity?: Types.Maybe<
        { __typename?: 'MarketActivityStats' } & MarketActivityFragment
    >;
    yearTerracedActivity?: Types.Maybe<
        { __typename?: 'MarketActivityStats' } & MarketActivityFragment
    >;
    yearFlatActivity?: Types.Maybe<
        { __typename?: 'MarketActivityStats' } & MarketActivityFragment
    >;
};

export const PropertiesSearchResponseErrorFragmentDoc = gql`
    fragment PropertiesSearchResponseError on PropertiesSearchResponseError {
        errors {
            message
        }
    }
`;
export const PropertiesSearchConnectionFragmentDoc = gql`
    fragment PropertiesSearchConnection on PropertiesSearchConnection {
        pageInfo {
            hasPreviousPage
            hasNextPage
            startCursor
            endCursor
        }
        totalResults
        metaData {
            geoAlias
            geoDescription
            geoName
            geoCountyAreaName
            geoPostalArea
            geoPostTownName
            geoRegionName
            geoOutcode
            geoOutcodes
            geoIncode
            input {
                geoString
                geoIdentifier
            }
        }
        edges {
            cursor
            node {
                uprn
                propertyId
                lastSale {
                    date
                    price
                }
                address {
                    uprn
                    fullAddress
                    postcode
                }
                attributes {
                    bathrooms
                    bedrooms
                    livingRooms
                    propertyType
                    tenure
                }
                saleEstimate {
                    lowerPrice
                    upperPrice
                }
                trackedProperty {
                    isTracked
                    relationship
                }
            }
        }
    }
`;
export const HousePricesResultsDocument = gql`
    query housePricesResults(
        $path: String!
        $geoIdentifier: GeoIdentifier
        $geoString: NonEmptyString
        $houseType: HouseType
        $rangeMonths: MarketActivityWindow
        $after: ID
        $first: PositiveInt
        $fromLastSaleDate: String
        $propertyTypeCode: String
        $sortDirection: String
        $sortOrder: String
        $toLastSaleDate: String
    ) {
        propertiesSearch(
            after: $after
            first: $first
            input: {
                geoIdentifier: $geoIdentifier
                fromLastSaleDate: $fromLastSaleDate
                propertyTypeCode: $propertyTypeCode
                sortDirection: $sortDirection
                sortOrder: $sortOrder
                toLastSaleDate: $toLastSaleDate
            }
        ) {
            ...PropertiesSearchConnection
            ...PropertiesSearchResponseError
        }
        area(geoIdentifier: $geoIdentifier, geoString: $geoString) {
            ...Area
        }
        breadcrumbs(path: $path) {
            text: label
            id: tracking
            href: uri
        }
        marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            houseType: $houseType
            rangeMonths: $rangeMonths
        ) {
            ...MarketActivity
        }
        yearAllActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: ALL
        ) {
            ...MarketActivity
        }
        yearDetachedActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: DETACHED
        ) {
            ...MarketActivity
        }
        yearSemiActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: SEMI_DETACHED
        ) {
            ...MarketActivity
        }
        yearTerracedActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: TERRACED
        ) {
            ...MarketActivity
        }
        yearFlatActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: FLAT
        ) {
            ...MarketActivity
        }
    }
    ${PropertiesSearchConnectionFragmentDoc}
    ${PropertiesSearchResponseErrorFragmentDoc}
    ${AreaFragmentDoc}
    ${MarketActivityFragmentDoc}
`;

/**
 * __useHousePricesResultsQuery__
 *
 * To run a query within a React component, call `useHousePricesResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHousePricesResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHousePricesResultsQuery({
 *   variables: {
 *      path: // value for 'path'
 *      geoIdentifier: // value for 'geoIdentifier'
 *      geoString: // value for 'geoString'
 *      houseType: // value for 'houseType'
 *      rangeMonths: // value for 'rangeMonths'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      fromLastSaleDate: // value for 'fromLastSaleDate'
 *      propertyTypeCode: // value for 'propertyTypeCode'
 *      sortDirection: // value for 'sortDirection'
 *      sortOrder: // value for 'sortOrder'
 *      toLastSaleDate: // value for 'toLastSaleDate'
 *   },
 * });
 */
export function useHousePricesResultsQuery(
    baseOptions: Apollo.QueryHookOptions<
        HousePricesResultsQuery,
        HousePricesResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        HousePricesResultsQuery,
        HousePricesResultsQueryVariables
    >(HousePricesResultsDocument, options);
}
export function useHousePricesResultsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        HousePricesResultsQuery,
        HousePricesResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        HousePricesResultsQuery,
        HousePricesResultsQueryVariables
    >(HousePricesResultsDocument, options);
}
export type HousePricesResultsQueryHookResult = ReturnType<
    typeof useHousePricesResultsQuery
>;
export type HousePricesResultsLazyQueryHookResult = ReturnType<
    typeof useHousePricesResultsLazyQuery
>;
export type HousePricesResultsQueryResult = Apollo.QueryResult<
    HousePricesResultsQuery,
    HousePricesResultsQueryVariables
>;
